import { AccountCurrencySettings } from '@/components/account/AccountCurrencySettings';
import { AccountCompanyProfileSettings } from '@/components/account/AccountCompanyProfileSettings';
import { AccountDisplayNameSettings } from '@/components/account/AccountDisplayNameSettings';
import { useAuth } from '@/lib/auth';
import { AccountType } from '@paladin-monorepo/common';

export function GeneralSettingsTab() {
  const { user } = useAuth({ middleware: 'auth', tmp: 'GeneralSettingsTab' });

  return (
    <div className="flex flex-col gap-8 max-w-2xl">
      {user?.currentAccountId && (
        <AccountDisplayNameSettings accountId={user.currentAccountId} />
      )}
      {user?.currentAccountId && user.account?.accountType === AccountType.Inquirer && (
        <AccountCompanyProfileSettings accountId={user.currentAccountId} />
      )}
      {user?.currentAccountId && (
        <AccountCurrencySettings
          accountId={user.currentAccountId}
          currentDefaultCurrency={user.account?.defaultCurrency}
        />
      )}
    </div>
  );
}
